import * as React from "react";
import { forwardRef } from "react";
const SvgCirclePartial = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "1.35 1.35 13.3 13.3", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Icons-/-functions-/-circle-partial", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("circle", { stroke: "currentColor", strokeWidth: 1, cx: 8, cy: 8, r: 6 }), /* @__PURE__ */ React.createElement("path", { d: "M8,8 L8,2.5 A5.5,5.5 0 0 1 12.763,10.75 Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgCirclePartial);
export default ForwardRef;
